import { Navigate } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canAccessClasificacionRuts } from '../utils/gestionCampanaAccess'

/** Acceso exclusivo: un solo correo (CLASIFICACION_RUTS_ALLOWED_EMAIL). */
const RequireClasificacionRutsAccess = ({ children }) => {
  const { user } = useUser()
  if (!canAccessClasificacionRuts(user)) {
    return <Navigate to="/inicio" replace />
  }
  return children
}

export default RequireClasificacionRutsAccess
